import { Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const PageHeader = ({ title, text, withBackButton, onBack, children }) => {
  return (
    <div className={styles.pageHeader}>
      <div className={`${styles.pageHeaderCell} ${withBackButton && styles.pageHeaderCellBack}`}>
        {withBackButton && (
          <Button type="text" icon={<CroplerIcon name="prev" />} className={styles.pageHeaderBack} onClick={onBack}/>
        )}
        <p className={styles.pageHeaderTitle}>{title}</p>
        {text && <p className={styles.pageHeaderText}>{text}</p>}
      </div>
      {children && <div>{children}</div>}
    </div>
  );
};

export default PageHeader;
